/**
 * NOTE: I'm doing things a bit hacky here.
 * Normally, controls are rendered with the `controls` array, and
 * that state is owned by Demo. The problem here is that I need to
 * run an effect whenever that state changes, to calculate the
 * actual bounding box sizes. And I want to show that after the
 * component.
 *
 * So, instead, I'm owning the state in this component and rendering
 * the controller manually, outside the `controls` array.
 */

import React from 'react';
import { styled } from '@linaria/react';

import SliderControl from '@/components/Controls/SliderControl';

import FlexDemo from './FlexDemo';
import Output from './Output';
import ShrinkItem from './ShrinkItem';

const DEFAULT_FLEX_BASIS = 200;

function ShrinkIntro() {
  const firstItemRef = React.useRef();
  const secondItemRef = React.useRef();

  const [firstBB, setFirstBB] = React.useState(null);
  const [secondBB, setSecondBB] = React.useState(null);

  const [flexBasis, setFlexBasis] = React.useState(
    DEFAULT_FLEX_BASIS
  );

  const [shrunkBy, setShrunkBy] = React.useState(0);

  React.useEffect(() => {
    if (!firstItemRef.current || !secondItemRef.current) {
      return;
    }

    const firstBB = firstItemRef.current.getBoundingClientRect();

    setFirstBB(firstBB);
    setSecondBB(secondItemRef.current.getBoundingClientRect());

    setShrunkBy(100 - Math.round((firstBB.width / flexBasis) * 100));
  }, [flexBasis]);

  return (
    <FlexDemo
      centered
      initialValues={{
        '--direction': 'row',
      }}
    >
      {(state) => (
        <div style={{ width: 612 }}>
          <Output state={state}>
            <ShrinkItem
              primary
              ref={firstItemRef}
              boundingBox={firstBB}
              flexBasis={flexBasis}
              shrunkBy={shrunkBy}
              actualSizeOverride={flexBasis === 800 ? 480 : undefined}
            />
            <ShrinkItem
              ref={secondItemRef}
              boundingBox={secondBB}
              flexBasis={DEFAULT_FLEX_BASIS}
              shrunkBy={shrunkBy}
              actualSizeOverride={flexBasis === 800 ? 120 : undefined}
            />
          </Output>
          <PseudoControlWrapper>
            <SliderControl
              key="flexBasis"
              id="flexBasis"
              label="flex-basis"
              min={DEFAULT_FLEX_BASIS}
              max={800}
              value={flexBasis}
              setValue={setFlexBasis}
              wrapperStyle={{
                color: 'hsl(50deg 100% 65%)',
                fontWeight: 'var(--font-weight-medium)',
              }}
            />
          </PseudoControlWrapper>
        </div>
      )}
    </FlexDemo>
  );
}

const PseudoControlWrapper = styled.div`
  max-width: 400px;
  margin-top: 16px;
  margin-left: auto;
  margin-right: auto;
`;

export default ShrinkIntro;
